import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "@/components/ui/sonner";
import { useAuth } from "@/context/AuthContext";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger,
} from "@/components/ui/dialog";

export default function FeedbackDialog() {
  const { user } = useAuth();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;
    setSending(true);
    try {
      await api.post("/feedback", {
        message: message.trim(),
        email: !user && email.trim() ? email.trim() : undefined,
        page: location.pathname,
      });
      toast.success("Thanks! Your feedback was sent 💌");
      setMessage("");
      setEmail("");
      setOpen(false);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Couldn't send feedback");
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          className="text-sm text-[#8C3A3A] hover:underline underline-offset-2"
          data-testid="footer-feedback-link"
        >
          Feedback
        </button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md" data-testid="feedback-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif-display text-2xl">Share your feedback</DialogTitle>
          <DialogDescription>
            We're a brand-new site and still building. Tell us what's broken or what you'd love to see.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <textarea
            className="mp-input min-h-[120px]"
            placeholder="Your thoughts, bugs, or ideas…"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            data-testid="feedback-message-input"
            required
          />
          {!user && (
            <input
              type="email"
              className="mp-input"
              placeholder="Your email (optional, so we can reply)"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="feedback-email-input"
            />
          )}
          <button
            type="submit"
            className="btn-primary w-full"
            disabled={sending || !message.trim()}
            data-testid="feedback-submit-btn"
          >
            {sending ? "Sending…" : "Send feedback"}
          </button>
          <p className="text-xs text-[#8A8A8A] text-center">
            Prefer email? Reach us at{" "}
            <a href="mailto:info@memorypeaks.com" className="underline text-[#8C3A3A]">
              info@memorypeaks.com
            </a>
          </p>
        </form>
      </DialogContent>
    </Dialog>
  );
}
